import { createSlice } from '@reduxjs/toolkit'
import { 
  createUpdateCondition, 
  fetchConditionList, 
  deleteCondition,
  toggleStatus, 
  sendActivationLink, 
  sendResetPasswordLink,
  getConditionByConditionId ,
  addSectionToCondition,
  deleteSectionFromCondition,
  deleteFileFromSection,
  fetchPublicConditions,
  fetchSingleCondition,
  publishCondition,
  reorderSections,
 } from '../actions/conditionsAction'

export const conditions = createSlice({
  name: 'conditions',
  initialState: {
    conditions: null,
    currentCondition: null,
    sections:[],
    isChanges:false,
    error: null,
    sortBy: null,
    isLoader: false,
    isRecordAdded: false,
    isRecordUpdated: false,
    isRecordLoaded:false,
    isSectionInserted:false,
    currentStep: 0,
    publicConditions:null,
    singleCondition:null,
    isManageConditionPage:false,
  },
  reducers: {
    resetCondition: state => {
      state.currentCondition= null;
      state.isRecordAdded = false;
      state.isRecordLoaded = false;
      state.isRecordAdded = false;
    },
    resetSection: state => {
      state.isSectionInserted=false
    },
    resetStep: state => {
      state.currentStep = 0;
      state.error = null;
    },
    updateChanges: (state, {payload}) =>{
      state.isChanges = payload;
    },
    
    setCurrentStep: (state, {payload})=> {
      state.currentStep = payload;
      state.error = null;
    },
   
    resetPopup: state => {
      state.isLoader= false
      state.isRecordAdded= false
      state.isRecordUpdated= false
      state.error = null;
    },
    updateSection:(state, {payload}) => {
      state.sections=[...state.sections,payload]   
      state.isSectionInserted = true;
    },
    removeSection:(state, {payload}) => {  
      state.sections=state.sections.filter((_, payload) => payload !== 0)
      state.isSectionInserted = true; 
    },

    setManageConditionPage: state => {
      state.isManageConditionPage = true;
    },
    resetManageConditionPage: state => {
      state.isManageConditionPage = false;
    },
    updatePublicCondition:(state, {payload}) => {  
      state.publicConditions.conditions=payload;
    },
  },

 

  extraReducers: {
    [fetchPublicConditions.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
    },
    [fetchPublicConditions.fulfilled]: (state, {payload}) => {
      state.error=null;
      state.publicConditions=payload?.data;
      state.isLoader= false
    
    },
    [fetchPublicConditions.rejected]: (state, {payload}) => {
      state.error= payload;
      state.publicConditions=null;
      state.isLoader= false;
    },
    [fetchSingleCondition.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
    },
    [fetchSingleCondition.fulfilled]: (state, {payload}) => {
      state.error=null;
      state.singleCondition=payload?.data;
      state.isLoader= false
    
    },
    [fetchSingleCondition.rejected]: (state, {payload}) => {
      state.error= payload;
      state.singleCondition=null;
      state.isLoader= false;
    },
    [fetchConditionList.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
    },
    [fetchConditionList.fulfilled]: (state, {payload}) => {
      state.error=null;
      return {
        ...state,
        ...payload?.data,
        isLoader: false,
       isRecordUpdated: false,
      }
    },
    [fetchConditionList.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader= false;
    },
    [createUpdateCondition.pending]: (state, payload) => {
      state.error=null;
      state.isRecordAdded=false;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [createUpdateCondition.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isRecordAdded=true;
      state.isRecordUpdated= true;
      state.currentCondition= payload?.data;
      state.isSectionInserted = true;
      state.isLoader= false;
      
    },
    [createUpdateCondition.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordAdded=false;
      state.isRecordUpdated= false
      state.isLoader= false;
    },
    [deleteCondition.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false
      state.isLoader= true;
    },
    [deleteCondition.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [deleteCondition.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false
      state.isLoader= false;
    },
    [toggleStatus.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false
      state.isLoader= true;
    },
    [toggleStatus.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [toggleStatus.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false
      state.isLoader= false;
    },
    [publishCondition.pending]: (state, payload) => {
      state.error = null;
      state.isLoader= true;
    },
    [publishCondition.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isLoader= false;
    },
    [publishCondition.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader= false;
    },
    [sendActivationLink.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false
      state.isLoader= true;
    },
    [sendActivationLink.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [sendActivationLink.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    [sendResetPasswordLink.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false
      state.isLoader= true;
    },
    [sendResetPasswordLink.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [sendResetPasswordLink.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    [getConditionByConditionId.pending]: (state, payload) => {
      state.error=null;
      state.isRecordLoaded= false ;
      state.isLoader= true;
    },
    [getConditionByConditionId.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordLoaded= true;
      state.currentCondition= payload?.data;
      state.isLoader= false;
    },
    [getConditionByConditionId.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordLoaded= false;
      state.isLoader= false;
      state.currentCondition= null;
    },
    [addSectionToCondition.pending]: (state, payload) => {
      state.error=null;
      state.isRecordAdded=false;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [addSectionToCondition.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isRecordAdded=true;
      state.isRecordUpdated= true;
      state.currentCondition= payload?.data;
      state.isSectionInserted = true;
      state.isLoader= false;
      
    },
    [addSectionToCondition.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordAdded=false;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    [deleteSectionFromCondition.pending]: (state, payload) => {
      state.error=null;
      state.isRecordAdded=false;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [deleteSectionFromCondition.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isRecordAdded=true;
      state.isRecordUpdated= true;
      state.currentCondition= payload?.data;
      state.isSectionInserted = true;
      state.isLoader= false;
      
    },
    [deleteSectionFromCondition.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordAdded=false;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    [deleteFileFromSection.pending]: (state, payload) => {
      state.error=null;
      state.isRecordAdded=false;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [deleteFileFromSection.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isRecordAdded=true;
      state.isRecordUpdated= true;
      state.currentCondition= payload?.data;
      state.isSectionInserted = true;
      state.isLoader= false;
      
    },
    [deleteFileFromSection.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordAdded=false;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    [reorderSections.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [reorderSections.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isRecordUpdated= true;
      state.currentCondition= payload?.data;
      state.isLoader= false;
      
    },
    [reorderSections.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    
    
  }
})

// Action creators are generated for each case reducer function
export const {updatePublicCondition, updateChanges, resetStep,resetSection, setCurrentStep, resetPopup, resetCondition, updateSection, removeSection, setManageConditionPage, resetManageConditionPage } = conditions.actions

export default conditions.reducer